import React, { useEffect, useState } from 'react';
import {
    Col,
    Row,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Collapse,
    Button,
} from 'reactstrap';
import { useSearchParams } from 'react-router-dom';
import PhoneInput from "../../../../../components/Forms/PhoneInput";
import { fetchCompanyNames } from "../../../../../api/requests/company-requests";
import { COMPANY_TYPES } from "../../../../../constants/companyTypes";
import { getPaymentTypeMeta } from '../paymentTypeMeta';
const PayerInfoSection = ({
                              validation,
                              isAccountRole,
                              accounts,
                              clearCardValidationState,
                              isStaffAdmin = false,
                              selectedCompanyId,
                              setSelectedCompanyId,
                              // Yeni tasarımda başlık sayfa üst şeridinde duruyor; bölümün
                              // kendi <h5>'i çift başlık yaratmasın diye gizlenebilir.
                              hideHeading = false,
                          }) => {
    const { setFieldValue, values, touched, errors } = validation;
    const [searchParams] = useSearchParams();

    const [isNavyHover, setNavyHover] = useState(false);
    const [isOrangeHover, setOrangeHover] = useState(false);
    const [urlType, setUrlType] = useState(null);
    const actionWord = isAccountRole ? 'Ödeme' : 'Tahsilat';

    const [companies, setCompanies] = useState([]);
    const [companiesLoading, setCompaniesLoading] = useState(false);
    const [companiesErr, setCompaniesErr] = useState('');

    useEffect(() => {
        const type = searchParams.get('type');
        setUrlType(type);
        if (type === 'account') {
            setFieldValue('useInvoiceFields', false);
            setFieldValue('invoiceCompanyName', '');
            setFieldValue('invoiceTaxNumber', '');
            setFieldValue('invoiceTcNumber', '');
            setFieldValue('invoiceTaxOffice', '');
            setFieldValue('invoiceAddress', '');
            setFieldValue('invoiceAccountType', '');
            setFieldValue('email', '');
            setFieldValue('userPhone', '');
            setFieldValue('userAddress', '');
            // cari id sıfırla
            setFieldValue('accountId', '');
        } else if (type === 'invoice') {
            setFieldValue('useInvoiceFields', true);
            setFieldValue('accountId', '');
        } else if (type === 'normal') {
            // normal modda hiçbir şey seçili olmamalı
            setFieldValue('useInvoiceFields', null);
            setFieldValue('accountId', '');
            setFieldValue('invoiceCompanyName', '');
            setFieldValue('invoiceTaxNumber', '');
            setFieldValue('invoiceTcNumber', '');
            setFieldValue('invoiceTaxOffice', '');
            setFieldValue('invoiceAddress', '');
            setFieldValue('invoiceAccountType', '');
            setFieldValue('email', '');
            setFieldValue('userPhone', '');
            setFieldValue('userAddress', '');
            if (isStaffAdmin) setSelectedCompanyId?.('');
        }
    }, [searchParams, setFieldValue, isStaffAdmin, setSelectedCompanyId]);

    // Hesap rolü davranışı (staff admin değilken geçerli)
    useEffect(() => {
        if (!isStaffAdmin) {
            if (isAccountRole && accounts.length === 1) {
                setFieldValue('accountId', accounts[0].id);
                setFieldValue('useInvoiceFields', false);
            } else if (isAccountRole && values.useInvoiceFields === null) {
                setFieldValue('useInvoiceFields', false);
            }
        }
    }, [isAccountRole, accounts, setFieldValue, values.useInvoiceFields, isStaffAdmin]);

    const handlePayerChoiceChange = (value) => {
        setFieldValue('useInvoiceFields', value);
        clearCardValidationState();

        if (value === true) {
            // fatura
            setFieldValue('accountId', '');
            // staff admin ise firma seçimi dursa da fatura açılınca firma rolü opsiyonel
        } else if (value === false) {
            // cari/firma
            setFieldValue('invoiceCompanyName', '');
            setFieldValue('invoiceTaxNumber', '');
            setFieldValue('invoiceTcNumber', '');
            setFieldValue('invoiceTaxOffice', '');
            setFieldValue('invoiceAddress', '');
            setFieldValue('invoiceAccountType', '');
            setFieldValue('email', '');
            setFieldValue('userPhone', '');
            setFieldValue('userAddress', '');
        }
    };

    // URL type'ına göre butonları göster/gizle
    const shouldShowButtons =
        !isAccountRole &&
        urlType !== 'normal' &&
        urlType !== 'account' &&
        urlType !== 'invoice';

    // Bölüm görünürlükleri:
    // Staff admin ise "account" bölümü yerine "firma seçimi" bölümü kullanılır
    const shouldShowAccountSection =
        (!isStaffAdmin && (urlType === 'account' || (urlType !== 'normal' && urlType !== 'invoice' && values.useInvoiceFields === false) || isAccountRole))
        || (isStaffAdmin && (urlType === 'account' || (urlType !== 'normal' && urlType !== 'invoice' && values.useInvoiceFields === false)));

    // Opsiyonel telefon yalnız fatura DIŞINDAKİ tiplerde gösterilir; fatura
    // bölümünün kendi zorunlu telefon alanı vardır.
    const showOptionalPhone = urlType === 'normal' || urlType === 'account';

    const shouldShowInvoiceSection =
        urlType === 'invoice' ||
        (urlType !== 'normal' && urlType !== 'account' && !isAccountRole && values.useInvoiceFields === true);

    // Başlık ortak meta'dan gelir; sayfa üst şeridiyle tek kaynaktan beslenir.
    const getTitle = () =>
        getPaymentTypeMeta(urlType, { isAccountRole, isStaffAdmin }).title;

    // NEW: Staff admin ise şirketleri çek
    useEffect(() => {
        if (!isStaffAdmin) return;

        const run = async () => {
            try {
                setCompaniesLoading(true);
                setCompaniesErr('');
                const resp = await fetchCompanyNames();
                if (!resp.ok) {
                    const j = await resp.json().catch(() => ({}));
                    throw new Error(j?.message || 'Firma listesi alınamadı');
                }
                const j = await resp.json();
                setCompanies(j?.data || []);
            } catch (e) {
                setCompaniesErr(e?.message || 'Firma listesi alınamadı');
                setCompanies([]);
            } finally {
                setCompaniesLoading(false);
            }
        };

        run();
    }, [isStaffAdmin]);

    return (
        <div className={hideHeading ? '' : 'mb-4'}
             style={hideHeading ? undefined : { borderBottom: '1px solid #eee', paddingBottom: '1.5rem' }}>
            {/* Başlık gizliyken ve mod butonları da yoksa (anlık tahsilat) bu satır
                tamamen boş kalıyor ama mb-3 kadar yer kaplıyordu; bu da "Ödeme Bilgileri"
                kartını sağdaki kart görselinden bir tık aşağı kaydırıyordu. İçeriği
                olmadığında hiç render edilmez. */}
            {(!hideHeading || shouldShowButtons) && (
            <Row className="d-flex justify-content-between align-items-center mb-3">
                {!hideHeading && (
                    <Col xs="6" md="5">
                        <h5 className="mb-0">{getTitle()}</h5>
                    </Col>
                )}

                {shouldShowButtons && (
                    <Col xs="6" md="7" className="d-flex justify-content-end" style={{ gap: '0.5rem' }}>
                        {/* Cari/Bayi Seç / Firma Seç butonu */}
                        <Button
                            className="btn-sm rounded-pill"
                            style={{
                                backgroundColor: values.useInvoiceFields === false ? '#0A316E' : (isNavyHover ? '#0A316E' : 'transparent'),
                                borderColor: '#0A316E',
                                color: values.useInvoiceFields === false || isNavyHover ? 'white' : '#0A316E',
                                fontWeight: 500,
                                transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={() => setNavyHover(true)}
                            onMouseLeave={() => setNavyHover(false)}
                            onClick={() => handlePayerChoiceChange(false)}
                        >
                            {isStaffAdmin ? 'Firma Seç' : 'Cari/Bayi Seç'}
                        </Button>

                        {/* Fatura Ekle Butonu */}
                        <Button
                            className="btn-sm rounded-pill"
                            style={{
                                backgroundColor: values.useInvoiceFields === true ? '#FFA500' : (isOrangeHover ? '#FFA500' : 'transparent'),
                                borderColor: '#FFA500',
                                color: values.useInvoiceFields === true || isOrangeHover ? 'white' : '#FFA500',
                                fontWeight: 500,
                                transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={() => setOrangeHover(true)}
                            onMouseLeave={() => setOrangeHover(false)}
                            onClick={() => handlePayerChoiceChange(true)}
                        >
                            Fatura Ekle
                        </Button>
                    </Col>
                )}
            </Row>
            )}

            {/* Cari/Bayi veya Firma Seçimi Bölümü */}
            <Collapse isOpen={shouldShowAccountSection}>
                {!isStaffAdmin ? (
                    // Mevcut: Cari/Bayi seçimi
                    <FormGroup>
                        <Label htmlFor="accountId">
                            {isAccountRole ? 'Cari/Bayi Hesabınız' : 'Cari/Bayi Seçiniz (opsiyonel)'}
                        </Label>
                        <Input
                            type="select"
                            id="accountId"
                            name="accountId"
                            value={values.accountId}
                            onChange={(e) => {
                                validation.handleChange(e);
                                if (e.target.value) {
                                    handlePayerChoiceChange(false);
                                }
                            }}
                            disabled={isAccountRole}
                        >
                            {!isAccountRole && (
                                <option value="">— Cari/Bayi seçmeden devam et —</option>
                            )}
                            {accounts.map((acc) => (
                                <option key={acc.id} value={acc.id}>
                                    {acc.accountCode && `${acc.accountCode} — `}
                                    {acc.accountName}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                ) : (
                    // NEW: Staff Admin → Firma Seçimi
                    <FormGroup>
                        <Label htmlFor="selectedCompanyId">Firma Seçiniz*</Label>
                        <Input
                            type="select"
                            id="selectedCompanyId"
                            name="selectedCompanyId"
                            value={selectedCompanyId || ''}
                            onChange={(e) => {
                                const val = e.target.value || '';
                                setSelectedCompanyId?.(val);
                                // Firma ile tahsilat moduna geçildiğinde invoice kapansın
                                handlePayerChoiceChange(false);
                                // Cari seçimi temizle
                                validation.setFieldValue('accountId', '');
                            }}
                        >
                            <option value="" disabled={companiesLoading}>
                                {companiesLoading ? 'Yükleniyor...' : '— Firma seçiniz —'}
                            </option>
                            {companies.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.companyName}
                                </option>
                            ))}
                        </Input>
                        {companiesErr && (
                            <div className="text-danger mt-1">
                                <small>{companiesErr}</small>
                            </div>
                        )}
                    </FormGroup>
                )}
            </Collapse>

            {/* Opsiyonel telefon — Anlık ve Cari/Bayi ekranlarında.
                Fatura ekranında telefon zaten ZORUNLU bir alan olarak aşağıda var,
                bu yüzden orada tekrar gösterilmez.
                Boş bırakılabilir; doldurulursa 10 hane olmalıdır (doğrulama
                PaymentForm'daki Yup şemasında). Boşken mevcut davranış korunur:
                anlık tahsilatta oturum sahibinin profil telefonu gönderilir. */}
            {showOptionalPhone && (
                <PhoneInput
                    label="Telefon Numarası (opsiyonel)"
                    name="userPhone"
                    value={values.userPhone}
                    onChange={(e) => validation.setFieldValue(e.target.name, e.target.value)}
                    onBlur={validation.handleBlur}
                    invalid={touched.userPhone && !!errors.userPhone}
                    errorText={errors.userPhone}
                />
            )}

            {/* Fatura Formu Bölümü */}
            <Collapse isOpen={shouldShowInvoiceSection}>
                <FormGroup className="mb-3">
                    <Label htmlFor="invoiceAccountType">Firma Tipi*</Label>
                    <Input
                        type="select"
                        id="invoiceAccountType"
                        name="invoiceAccountType"
                        value={values.invoiceAccountType}
                        onChange={validation.handleChange}
                        invalid={touched.invoiceAccountType && !!errors.invoiceAccountType}
                    >
                        <option value="">Seçiniz</option>
                        {COMPANY_TYPES.map(({ value, label }) => (
                            <option key={value} value={value}>
                                {label}
                            </option>
                        ))}
                    </Input>
                    <FormFeedback>{errors.invoiceAccountType}</FormFeedback>
                </FormGroup>

                <FormGroup className="mb-3">
                    <Label htmlFor="invoiceCompanyName">Firma Ünvanı*</Label>
                    <Input
                        id="invoiceCompanyName"
                        name="invoiceCompanyName"
                        value={values.invoiceCompanyName}
                        onChange={validation.handleChange}
                        invalid={touched.invoiceCompanyName && !!errors.invoiceCompanyName}
                    />
                    <FormFeedback>{errors.invoiceCompanyName}</FormFeedback>
                </FormGroup>

                {values.invoiceAccountType === 'SOLE_PROPRIETORSHIP' ? (
                    <FormGroup className="mb-3">
                        <Label htmlFor="invoiceTcNumber">TC Kimlik No*</Label>
                        <Input
                            id="invoiceTcNumber"
                            name="invoiceTcNumber"
                            type="text"
                            placeholder="TC Kimlik Numarası Giriniz"
                            maxLength="11"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={values.invoiceTcNumber}
                            onChange={(e) => {
                                const sanitizedValue = e.target.value.replace(/\D/g, '');
                                setFieldValue('invoiceTcNumber', sanitizedValue);
                            }}
                            onBlur={validation.handleBlur}
                            invalid={touched.invoiceTcNumber && !!errors.invoiceTcNumber}
                        />
                        <FormFeedback>{errors.invoiceTcNumber}</FormFeedback>
                    </FormGroup>
                ) : (
                    values.invoiceAccountType && (
                        <FormGroup className="mb-3">
                            <Label htmlFor="invoiceTaxNumber">Vergi No*</Label>
                            <Input
                                id="invoiceTaxNumber"
                                name="invoiceTaxNumber"
                                value={values.invoiceTaxNumber}
                                inputMode="numeric"
                                maxLength="10"
                                onChange={(e) => {
                                    const onlyDigits = e.target.value.replace(/\D/g, '');
                                    setFieldValue('invoiceTaxNumber', onlyDigits);
                                }}
                                invalid={touched.invoiceTaxNumber && !!errors.invoiceTaxNumber}
                            />
                            <FormFeedback>{errors.invoiceTaxNumber}</FormFeedback>
                        </FormGroup>
                    )
                )}

                <FormGroup className="mb-3">
                    <Label htmlFor="email">E-posta Adresi*</Label>
                    <Input
                        type="email"
                        id="email"
                        name="email"
                        value={values.email}
                        onChange={validation.handleChange}
                        invalid={touched.email && !!errors.email}
                    />
                    <FormFeedback>{errors.email}</FormFeedback>
                </FormGroup>

                <PhoneInput
                    label="Telefon Numarası*"
                    name="userPhone"
                    value={values.userPhone}
                    onChange={(e) => validation.setFieldValue(e.target.name, e.target.value)}
                    onBlur={validation.handleBlur}
                    invalid={touched.userPhone && !!errors.userPhone}
                    errorText={errors.userPhone}
                />

                <FormGroup className="mb-3">
                    <Label htmlFor="invoiceTaxOffice">Vergi Dairesi*</Label>
                    <Input
                        id="invoiceTaxOffice"
                        name="invoiceTaxOffice"
                        value={values.invoiceTaxOffice}
                        onChange={validation.handleChange}
                        invalid={touched.invoiceTaxOffice && !!errors.invoiceTaxOffice}
                    />
                    <FormFeedback>{errors.invoiceTaxOffice}</FormFeedback>
                </FormGroup>

                <FormGroup className="mb-3">
                    <Label htmlFor="invoiceAddress">Adres*</Label>
                    <Input
                        type="textarea"
                        id="invoiceAddress"
                        name="invoiceAddress"
                        value={values.invoiceAddress}
                        onChange={validation.handleChange}
                        invalid={touched.invoiceAddress && !!errors.invoiceAddress}
                    />
                    <FormFeedback>{errors.invoiceAddress}</FormFeedback>
                </FormGroup>
            </Collapse>
        </div>
    );
};

export default PayerInfoSection;